import styled from 'styled-components';

export const TitleContainer = styled.h2`
  font-weight: 900;
  font-size: 3.6rem;
`;
